import { Component, Input, OnInit, Output, EventEmitter, ViewChild, ViewEncapsulation, ElementRef, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { FormFields } from 'app/views/campaign-3/components/form-fields/form-fields.component';
import { RulesService } from 'app/services/audit/rules.service';
import { AuditInfoBaseForm } from 'app/views/audit/models/audit-info-base.model';
import { AuditRuleObject, AuditRulesType, AuditTemplate, AuditTemplateAssignment, JsonSchema } from 'app/views/audit/models/audit-event.model';
import { Calendar } from 'fullcalendar';
import { FormGroup } from '@angular/forms';
import { Acm } from 'app/models/loyalty-acm.model';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';
import { ChallengeDetail, ChallengeResponse } from 'app/views/challenge/challenge.model';
import { ChallengeService } from 'app/views/challenge/challenge.service';

@Component({
  selector: 'app-audit-rule-base',
  templateUrl: './audit-rule-base.component.html',
  styleUrls: ['./audit-rule-base.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AuditInfoBaseComponent implements OnInit {

  errors: boolean = false;

  @Input() ui_mode: string = this.rulesService.ui_modes.CREATE;
  @Input() formSchema: any;
  @Input() readOnly: boolean = false;
  @Input() language: string = "it";
  @Input() dateFormat: string = "dd/MM/yyyy";
  @Input() schemaMode: string = this.rulesService.schema_modes.CREATE;
  @Input() clusterOption: SelectItem[];
  @Input() clusterOptionActive: SelectItem[];
  @Input() acmList: SelectItem[];
  @Input() acmListFull: Array<Acm>;
  @Input() challengeList: SelectItem[];
  @Input() challengeListFull: Array<ChallengeResponse>;
  @Input() listReasons: SelectItem[];
  @Input() auditRuleObject: AuditRuleObject;
  @Input() dateRangeForm: FormGroup;

  @Output() enableConfirmButton: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() formSchemaChanged: EventEmitter<JsonSchema> = new EventEmitter<JsonSchema>();
  @Output() actionChanged: EventEmitter<string> = new EventEmitter<string>();
  @Output() auditRuleObjectChange: EventEmitter<AuditRuleObject> = new EventEmitter<AuditRuleObject>();


  @ViewChild('desc_rule') desc_rule: ElementRef;
  @ViewChild('sorg_event') sorg_event: ElementRef;
  @ViewChild('rule_code') rule_code: ElementRef;
  @ViewChild('end_val_rule') end_val_rule: Calendar;
  @ViewChild('start_val_rule') start_val_rule: Calendar;
  @ViewChild('cluster') cluster: FormFields;
  @ViewChild('anag') anag: FormFields;
  @ViewChild('acm') acm: FormFields;
  @ViewChild('rule_challenge') rule_challenge: FormFields;
  @ViewChild('rule_challenge_detail') rule_challenge_detail: FormFields;
  @ViewChild('acm_active_range') acm_active_range: FormFields;
  @ViewChild('acm_min') acm_min: FormFields;
  @ViewChild('acm_max') acm_max: FormFields;
  @ViewChild('cinfo_nominativo') cinfo_nominativo: FormFields;
  @ViewChild('cinfo_blacklist') cinfo_blacklist: FormFields;
  @ViewChild('cinfo_newsletter') cinfo_newsletter: FormFields;
  @ViewChild('cinfo_recapiti') cinfo_recapiti: FormFields;
  @ViewChild('cinfo_privacy') cinfo_privacy: FormFields;
  @Input() actionsRulesType: Array<AuditRulesType>;
  @Input() actionsRulesTypeCombo: SelectItem[];
  @Input() listSchemas: Array<AuditTemplateAssignment>;
  @Input() listTemplates: Array<AuditTemplate>;
  challengeDetailList: SelectItem[] = [];
  challengeDetailListFull: Array<ChallengeDetail> = [];
  filteredChallengeList: SelectItem[] = [];

  infoBaseForm: AuditInfoBaseForm = new AuditInfoBaseForm();
  selectedRule: any = null;
  sorgEvent: any;
  ruleTypeTitle: string;
  modeView: string;
  fieldModel = {
    cluster: null,
    acm: null,
    acm_active_range: null,
    acm_min: null,
    acm_max: null,
    anag: null,
    cinfo_privacy: null,
    cinfo_recapiti: null,
    cinfo_newsletter: null,
    cinfo_blacklist: null,
    cinfo_nominativo: null,
    start_val_rule: null,
    end_val_rule: null,
    rule_code: null,
    desc_rule: null,
    sorg_event: null,
    rule_challenge: null,
    rule_challenge_detail: null,
    event_audit_table: null
  }

  ready = {
    form: false
  }

  show = {
    anag: false,
    acm: false,
    cluster: false
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private srvMessage: MessageService,
    public rulesService: RulesService,
    private translate: TranslateService,
    private challengeService: ChallengeService
  ) {
  }

  ngOnInit() {
    const startCtrl = this.dateRangeForm && this.dateRangeForm.get('date_start');
    const endCtrl = this.dateRangeForm && this.dateRangeForm.get('date_end');

    if (startCtrl) {
      startCtrl.valueChanges.subscribe(val => this.onDateChanged('start', val));
    }
    if (endCtrl) {
      endCtrl.valueChanges.subscribe(val => this.onDateChanged('end', val));
    }
  }

  get effectiveClusterOption(): SelectItem[] {
    const isEdit = this.auditRuleObject && this.auditRuleObject.rule && this.auditRuleObject.rule.id > 0;
    return isEdit ? this.clusterOption : (this.clusterOptionActive || this.clusterOption);
  }

  onClickExists() {
    this.enableConfirmButton.emit(true);
  }

  performValidationInfoBase(): boolean {

    this.infoBaseForm.valid = true;
    if (
      KoncentroValidators.isEmptyInputValue(this.desc_rule.nativeElement.value) ||
      KoncentroValidators.isEmptyInputValue(this.rule_code.nativeElement.value) ||
      KoncentroValidators.isEmptyInputValue(this.dateRangeForm.controls.date_end.value) ||
      KoncentroValidators.isEmptyInputValue(this.dateRangeForm.controls.date_start.value)
    ) {
      this.infoBaseForm.valid = false;
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('common.empty_fields')
      });
      return this.infoBaseForm.valid;
    }

    if (this.show.acm) {
      if (this.acm) { this.acm.performValidation(); }
      if (this.acm_active_range) { this.acm_active_range.performValidation(); }
      if (this.acm_min) { this.acm_min.performValidation(); }
      if (this.acm_max) { this.acm_max.performValidation(); }
      if ((this.acm && !this.acm.valid) ||
        (this.acm_active_range && !this.acm_active_range.valid) ||
        (this.acm_min && !this.acm_min.valid) ||
        (this.acm_max && !this.acm_max.valid)) {
        this.infoBaseForm.valid = false;
      }
    }

    if (this.show.cluster) {
      this.cluster.performValidation();
      if (!this.cluster.valid) {
        this.infoBaseForm.valid = false;
      }
      const clusterItem = this.fieldModel.cluster as any;
      if (clusterItem && clusterItem.date_end) {
        const dateEnd = new Date(clusterItem.date_end);
        dateEnd.setHours(23, 59, 59, 999);
        if (dateEnd < new Date()) {
          this.infoBaseForm.valid = false;
          this.srvMessage.add({
            severity: 'error',
            summary: this.translate.instant('common.error'),
            detail: this.translate.instant('audit.cluster_expired')
          });
        }
      }
    }

    if (this.show.anag) {
      this.cinfo_nominativo.performValidation();
      this.cinfo_blacklist.performValidation();
      this.cinfo_newsletter.performValidation();
      this.cinfo_recapiti.performValidation();
      this.cinfo_privacy.performValidation();
      if (!this.cinfo_privacy.valid ||
        !this.cinfo_recapiti.valid ||
        !this.cinfo_newsletter.valid ||
        !this.cinfo_blacklist.valid ||
        !this.cinfo_nominativo.valid) {
        this.infoBaseForm.valid = false;
      }
    }

    //il check è dovuto al cambio di logica per le challenge/sfide che non 
    //hanno accumulatore nelle regole ma presentano nel json template acm nascosto 
    //per permettere la compatibilità del form schema
    if (!this.show.anag && !this.show.acm && !this.show.cluster
      && (this.rule_challenge || this.rule_challenge_detail)) {
      if (this.rule_challenge) {
        this.rule_challenge.performValidation();
      }
      if (this.rule_challenge_detail) {
        this.rule_challenge_detail.performValidation();
      }
      if (!this.rule_challenge.valid ||
        !this.rule_challenge_detail.valid) {
        this.infoBaseForm.valid = false;
      }
    }
    return this.infoBaseForm.valid;
  }

  loadJsonSchema(typeRule: any) {
    if (this.ui_mode == this.rulesService.ui_modes.EDIT) {
      this.selectedRule = typeRule;
    }
    var actionRuleTypeIndex = this.actionsRulesType.findIndex(f => f.id === typeRule);
    let resSchema = this.listSchemas.find(f => f.assigned_to_id === typeRule
      && f.assignement_entity === "rules" && f.assignement_type === this.ui_mode);
    if (!resSchema) {
      resSchema = this.listSchemas.find(f => f.assigned_to_id === typeRule
        && f.assignement_entity === "rules" && f.assignement_type === this.rulesService.ui_modes.CREATE);
    }
    if (resSchema) {
      var self = this;
      let resTemplate = this.listTemplates.find(f => f.id === resSchema.template_id);
      if (resTemplate) {
        var newSchema = this.rulesService.getPreparedFormSchemasRules(resTemplate);
        self.formSchema = null;
        setTimeout(function () {
          self.formSchema = newSchema.properties.infoBase;
          newSchema.mode = self.schemaMode;
          self.formSchemaChanged.emit(newSchema);
          var self2 = self;
          setTimeout(function () {
            //self2.ready.form = true;
            //self2.enableConfirmButton.emit(true);
            // Controllo se selectedRule e description sono definiti
            let abc = self2.actionsRulesType[actionRuleTypeIndex];
            //setto il campo event_audit_table non modificabile
            self2.sorgEvent = abc.event_audit_table;
            // Logica per gestire il caso 'Cluster'
            self2.ruleTypeTitle = self.formSchema.description;
            if (abc.code === "cluster") {
              self2.show.cluster = true;
              self2.show.anag = false;
              self2.show.acm = false;
            } else if (abc.code === "anag") {
              self2.show.cluster = false;
              self2.show.anag = true;
              self2.show.acm = false;
              self2.fieldModel.anag = self2.actionsRulesType[actionRuleTypeIndex];
            } else if (abc.code === "acm") {
              self2.show.cluster = false;
              self2.show.anag = false;
              self2.show.acm = true;
            } else {
              self2.show.cluster = false;
              self2.show.anag = false;
              self2.show.acm = false;
            }
          }, 100)
        }, 100);
      } else {
        //caso non viene restituito ILTEMPLATE, devi fermarti (da gestire)!
        this.formSchemaChanged.emit(null);
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.no_template_schema')
        });
      }
    }
    else {
      //caso non viene restituito schema, devi fermarti (da gestire)!
      this.formSchemaChanged.emit(null);
      this.srvMessage.add({
        severity: 'error',
        summary: this.translate.instant('common.error'),
        detail: this.translate.instant('common.no_template_schema')
      });
    }
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  loadJsonSchemaCreate(typeRule: any) {
    if (this.ui_mode == this.rulesService.ui_modes.EDIT) {
      this.selectedRule = typeRule;
    }
    var actionRuleTypeIndex = this.actionsRulesType.findIndex(f => f.id === typeRule);
    this.rulesService.getJsonFormSchema('rules', this.ui_mode, typeRule).subscribe(resSchema => {
      if (resSchema) {
        var self = this;
        this.rulesService.getTemplateById(resSchema.template_id).subscribe(resTemplate => {
          if (resTemplate) {
            var newSchema = this.rulesService.getPreparedFormSchemasRules(resTemplate);
            self.formSchema = null;
            setTimeout(function () {
              self.formSchema = newSchema.properties.infoBase;
              newSchema.mode = self.schemaMode;
              self.formSchemaChanged.emit(newSchema);
              var self2 = self;
              setTimeout(function () {
                //self2.ready.form = true;
                //self2.enableConfirmButton.emit(true);
                // Controllo se selectedRule e description sono definiti
                let abc = self2.actionsRulesType[actionRuleTypeIndex];
                //setto il campo event_audit_table non modificabile
                self2.sorgEvent = abc.event_audit_table;
                // Logica per gestire il caso 'Cluster'
                self2.ruleTypeTitle = self.formSchema.description;

                if (abc.code === "cluster") {
                  self2.show.cluster = true;
                  self2.show.anag = false;
                  self2.show.acm = false;
                } else if (abc.code === "anag") {
                  self2.show.cluster = false;
                  self2.show.anag = true;
                  self2.show.acm = false;
                  self2.fieldModel.anag = self2.actionsRulesType[actionRuleTypeIndex];
                } else if (abc.code === "acm") {
                  self2.show.cluster = false;
                  self2.show.anag = false;
                  self2.show.acm = true;
                } else {
                  self2.show.cluster = false;
                  self2.show.anag = false;
                  self2.show.acm = false;
                }
              }, 100)
            }, 100);
          } else {
            //caso non viene restituito ILTEMPLATE, devi fermarti (da gestire)!
            this.formSchemaChanged.emit();
            this.srvMessage.add({
              severity: 'error',
              summary: this.translate.instant('common.error'),
              detail: this.translate.instant('common.no_template_schema')
            });
          }
        });
      }
      else {
        //caso non viene restituito schema, devi fermarti (da gestire)!
        this.formSchemaChanged.emit(null);
        this.srvMessage.add({
          severity: 'error',
          summary: this.translate.instant('common.error'),
          detail: this.translate.instant('common.no_template_schema')
        });
      }
    });
  }

  onChangeAcmRange(event: boolean) {
    this.fieldModel.acm_active_range = event;
    if (!event) {
      this.fieldModel.acm_max = null;
      this.fieldModel.acm_min = null;
    }
  }

  onChangeChallenge(challenge: SelectItem) {
    // Svuota la lista prima di popolarla
    this.challengeDetailList = [];
    //this.listReasonsFiltered.push({ value: null, label: 'null' });

    const params = [{ key: 'limit', value: '9999999' }];
    params.push({ key: 'flg_state', value: '0' });
    let challengeDetailListFull = this.challengeService.getCampaignChallengeDetails(challenge.value);
    challengeDetailListFull.subscribe(resp => {
      // Controlla se ci sono dati nella risposta
      if (resp && resp.length > 0) {
        for (const challengeDetail of resp) {
          this.challengeDetailList.push({
            value: challengeDetail.id,
            label: challengeDetail.description + " | " + challengeDetail.longDescr
          });
        }
        var self = this;
        setTimeout(function () {
          self.fieldModel.rule_challenge = challenge;
          // self.fieldModel.rule_challenge_detail = self.challengeDetailList.find(f => f.value === challenge.value);
        }, 100)
      }
    });
  }

  onDateChanged(which: 'start' | 'end', value: any) {
    const startCtrl = this.dateRangeForm && this.dateRangeForm.get('date_start');
    const endCtrl = this.dateRangeForm && this.dateRangeForm.get('date_end');
    if (startCtrl) {
      startCtrl.valueChanges.subscribe(val => this.onDateChanged('start', val));
    }
    if (endCtrl) {
      endCtrl.valueChanges.subscribe(val => this.onDateChanged('end', val));
    }

    // Se manca una delle due date, tieni la combo disabilitata e svuota le opzioni
    if (!startCtrl.value || !endCtrl.value) {
      this.filteredChallengeList = [];
      this.fieldModel.rule_challenge = null;
      this.challengeDetailList = [];
      this.fieldModel.rule_challenge_detail = null;
      return;
    }

    // Se l'intervallo è invertito, svuota
    if (startCtrl.value > endCtrl.value) {
      this.filteredChallengeList = [];
      this.fieldModel.rule_challenge = null;
      this.challengeDetailList = [];
      this.fieldModel.rule_challenge_detail = null;
      return;
    }

    // Filtra le challenge "comprese tra" le due date selezionate (inclusivo)
    const toDate = (s: string) => (s ? new Date(s) : null);

    const allowedIds = new Set(
      (this.challengeListFull || [])
        .filter(c => {
          const cs = toDate(c.dateStart);
          const ce = toDate(c.dateEnd);
          return !!cs && !!ce && cs <= startCtrl.value && ce >= endCtrl.value && c.numLevel > 0;
        })
        .map(c => c.id)
    );

    // Mantieni le label esistenti usando challengeList già costruita come SelectItem[]
    this.filteredChallengeList = (this.challengeList || []).filter(opt =>
      allowedIds.has(opt.value));

    // Reset selezioni non più valide
    if (!this.filteredChallengeList.some(opt => this.fieldModel.rule_challenge && opt.value === this.fieldModel.rule_challenge.value)) {
      this.fieldModel.rule_challenge = null;
      this.challengeDetailList = [];
      this.fieldModel.rule_challenge_detail = null;
    }
  }
} 



// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-rule-base/audit-rule-base.component.ts